/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi40IDJIMlY1LjJIMTIuNFYyWk0xMS42IDQuNEg0LjhWMi44SDExLjZWNC40Wk02LjQgNi40MDAwMkg0VjkuNjAwMDJINi40SDE0LjRWNi40MDAwMkg2LjRaTTEzLjYgOC44MDAwMkg2LjRWNy4yMDAwMkgxMy42VjguODAwMDJaTTEyLjQgMTRIMlYxMC44SDEyLjRWMTRaTTQuOCAxMy4ySDExLjZWMTEuNkg0LjhWMTMuMloiIGZpbGw9ImluaGVyaXQiLz4=";